// extracted by mini-css-extract-plugin
module.exports = {"list":"Activity_list__eVjAq","item":"Activity_item__sw8Sn","listMargin":"Activity_listMargin__gBcGX","listLeft":"Activity_listLeft__gJGmW","mt56":"Activity_mt56__LVFLd"};